import restaurantInstance from '../../../instance'

const printTableOrders = (tableId, data) => {
  return restaurantInstance.post(`/tables/${tableId}/orders/print`, data)
}

export default printTableOrders
